import { loadState } from "../../modules/localStorage";

export const GA_SET_GAME = "GA_SET_GAME";
export const GA_SET_GAME_TYPE = "GA_SET_GAME_TYPE";
export const GA_SET_GAME_STEP = "GA_SET_GAME_STEP";
export const GA_SET_LAST_PAGE_VIEW = "GA_SET_LAST_PAGE_VIEW";

export function setGame(gameName) {
  return {
    type: GA_SET_GAME,
    payload: gameName,
  };
}

export function setGameType(gameType) {
  return {
    type: GA_SET_GAME_TYPE,
    payload: gameType,
  };
}

export const setGameStep = (stepName) => ({
  type: GA_SET_GAME_STEP,
  payload: stepName,
});


export const setLastPageView = (lastPageView) => ({
  type: GA_SET_LAST_PAGE_VIEW,
  payload: lastPageView,
});

export const AnalyticsSetPageView = (dataName) => (dispatch, getState) => {
  const state = getState().ga_utilities;

  if (state.lastPageView !== dataName) {
    dispatch(setLastPageView(dataName));

    if (state.stepArray.length > 1) {
      const event_label = `${state.gameName} - ${state.gameType} - ${state.stepName}`;

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'abandon_purchase',
          {
            'event_category': 'Purchase',
            'event_label': `${state.gameName} - ${state.gameType} - ${state.stepName}`,
            'value': 1
          });
      }

      if (typeof fbq === 'function') {
        fbq('trackCustom', 'abandon_purchase', { event_category: 'Purchase', event_label: event_label });
      }
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view',
        {
          'event_category': 'Behavior',
          'event_label': `${dataName}`,
          'value': 1
        });
    }

    if (typeof fbq === 'function') {
      fbq('trackCustom', 'page_view', { event_category: 'Behavior', event_label: dataName });
    }
  }
};

export const AnalyticsSetGame = (gameName) => (dispatch, getState) => {
  dispatch(setGame(gameName));
  dispatch(setGameType(null));
  dispatch(setGameStep(null));

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'select_game',
      {
        'event_category': 'Games',
        'event_label': `${gameName}`,
        'value': 1
      });
  }

  if (typeof fbq === 'function') {
    fbq('trackCustom', 'select_game', { event_category: 'Games', event_label: gameName });
  }
};

export const AnalyticsSetGameType = (gameType) => (dispatch, getState) => {
  dispatch(setGameStep(null));
  const state = getState().ga_utilities;

  if (state.gameType !== gameType) {
    dispatch(setGameType(gameType));
    const event_label = `${state.gameName} - ${gameType}`;

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'select_game_type',
        {
          'event_category': 'Game Types',
          'event_label': event_label,
          'value': 1
        });

      window.gtag('event', 'start_purchase',
        {
          'event_category': 'Purchase',
          'event_label': event_label,
          'value': 0
        });
    }

    if (typeof fbq === 'function') {
      fbq('trackCustom', 'select_game_type', { event_category: 'Game Types', event_label: event_label });

      fbq('trackCustom', 'start_purchase', { event_category: 'Purchase', event_label: event_label });
    }
  }
};

export const AnalyticsSetGameStep = (stepName) => (dispatch, getState) => {
  const state = getState().ga_utilities;

  if (state.stepName !== stepName) {
    dispatch(setGameStep(stepName));
    const event_label = `${state.gameName} - ${state.gameType} - ${stepName}`;

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'purchase_step',
        {
          'event_category': 'Purchase',
          'event_label': event_label,
          'value': 1
        });
    }

    if (typeof fbq === 'function') {
      fbq('trackCustom', 'purchase_step', { event_category: 'Purchase', event_label: event_label });
    }
  }
};

export const AnalyticsSetSpecifics = (specificName) => (dispatch, getState) => {
  const state = getState().ga_utilities;
  const select_specifics_event_label = `${specificName} - ${state.gameName} - ${state.gameType}`;
  const purchase_step_event_label = `${state.gameName} - ${state.gameType} - ${state.stepName}`;

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'select_specifics',
      {
        'event_category': 'Game Interaction',
        'event_label': select_specifics_event_label,
        'value': 1
      });

    window.gtag('event', 'purchase_step',
      {
        'event_category': 'Purchase',
        'event_label': purchase_step_event_label,
        'value': 1
      });
  }

  if (typeof fbq === 'function') {
    fbq('trackCustom', 'select_specifics', { event_category: 'Game Interaction', event_label: select_specifics_event_label });

    fbq('trackCustom', 'purchase_step', { event_category: 'Purchase', event_label: purchase_step_event_label });
  }
};

export const AnalyticsSetFinishPurchase = (value=0.00, currency = 'BRL') => (dispatch, getState) => {
  dispatch(setGameStep({ stepName: null }));
  const state = getState().ga_utilities;
  const event_label = `${state.gameName} - ${state.gameType} - Finish Purchase`;

  if (loadState("user")) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'purchase',
        {
          'event_category': 'Purchase',
          'event_label': event_label,
          'value': 1
        });
    }

    if (typeof fbq === 'function') {
      fbq('track', 'purchase',
        {
          event_category: 'Purchase', 
          event_label: event_label,
          value: value,
          currency: currency
        });
    }
  } else {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'attempt_to_buy_no_login',
        {
          'event_category': 'User',
          'event_label': event_label,
          'value': 1
        });
    }

    if (typeof fbq === 'function') {
      fbq('trackCustom', 'attempt_to_buy_no_login', { event_category: 'User', event_label: event_label });
    }
  }
};

export const AnalyticsSetLogin = () => (dispatch, getState) => {
  const event_label = 'Login Successful';

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'login',
      {
        'event_category': 'User',
        'event_label': event_label,
        'value': 1
      });
  }

  if (typeof fbq === 'function') {
    fbq('trackCustom', 'login', { event_category: 'User', event_label: event_label });
  }
};

export const AnalyticsSetLogout = () => (dispatch, getState) => {
  const event_label = 'Logout Successful';

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'logout',
      {
        'event_category': 'User',
        'event_label': 'Logout Successful',
        'value': 1
      });
  }

  if (typeof fbq === 'function') {
    fbq('trackCustom', 'logout', { event_category: 'User', event_label: event_label });
  }
};



// WEBPACK FOOTER //
// ./src/reducers/analytics/analyticsActions.js